export const FETCH_TEACHERS_STATUS = "FETCH_TEACHERS_STATUS";

export const INSERT_TEACHER_STATUS = "INSERT_TEACHER_STATUS";

export const DELETE_TEACHER_STATUS = "DELETE_TEACHER_STATUS";

export const EDIT_TEACHER_STATUS = "EDIT_TEACHER_STATUS";
